let modals = Array.from(document.querySelectorAll('.modal'));
let modalOpeners = document.querySelectorAll('.modal_opener');
let modalClosers = document.querySelectorAll('.modal_closer');
let modalFades = document.querySelectorAll('.fade');

modalOpeners.forEach((modalOpener) => {
    modalOpener.addEventListener('pointerdown', function (e) {
        let modalTarget = this.dataset.modalTarget;
        modals.forEach((modal) => {
            modal.classList[modal.id == modalTarget ? 'add' : 'remove']('show');
        });
    });
});

modalClosers.forEach((modalCloser) => {
    modalCloser.addEventListener('pointerdown', function (e) {
        let modalTarget = this.dataset.modalTarget;
        let modal = modals.find((modal) => modal.id == modalTarget);
        modal && modal.classList.remove('show');
    });
});

modalFades.forEach((fade) => {
    fade.addEventListener('pointerdown', (e) => {
        if (e.target !== fade) return;
        let modal = e.target.closest('.modal');
        modal && modal.classList.remove('show');
    });
});

export const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.remove('show');
    }
};

export const openModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal) {
        modal.classList.add('show');
    }
};
